import LangEnum from '../../../lang/LangEnum';
import snackbarStore from '../../../stores/Snackbar.store';
import { TranslateType } from '../../translation/translationContext.types';
import { ordersRepository } from '../repositories/ordersRepository/orders.repository';

export const authorizeOrderPayment = async (orderId: string, translate: TranslateType) => {
  const response = await ordersRepository(orderId).authorizeOrderPayment();

  if (response.ok) {
    snackbarStore.handleMessage({
      type: 'success',
      message: translate(LangEnum.SNACKBAR_PAYMENT_AUTHORIZED),
    });
  } else {
    snackbarStore.handleMessage({
      type: 'error',
      message: translate(LangEnum.SNACKBAR_ERROR_ON_PAYMENT_AUTHORIZATION),
    });
  }
};
